// PopUp component
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
} from "@mui/lab";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Gallery from "./Gallery";
import GoogleMapComponent from "./GoogleMapComponent";

function GridContent({ data, onClose }) {
  const [activeTab, setActiveTab] = useState("basicInfo");

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  // Handle overlay click to close the popup
  const handleOverlayClick = () => {
    onClose();
  };

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div
        className="popup"
        style={{ zIndex: "100" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pop-tab">
          <div className="ui top attached tabular menu">
            <div
              className={`item ${activeTab === "basicInfo" ? "active" : ""}`}
              onClick={() => handleTabClick("basicInfo")}
            >
              Basic Info
            </div>
            <div
              className={`item ${activeTab === "driverInfo" ? "active" : ""}`}
              onClick={() => handleTabClick("driverInfo")}
            >
              Driver Info
            </div>
            <div
              className={`item ${activeTab === "images" ? "active" : ""}`}
              onClick={() => handleTabClick("images")}
            >
              Images
            </div>
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ margin: "0px", width: "295px" }}
          >
            {activeTab === "basicInfo" && (
              <div>
                <span>VOL-342808</span>
                <p>Progress 88%</p>
                <div className="ui divider"></div>

                <Timeline
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                  }}
                  style={{
                    margin: "0px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    padding: "0px",
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot color="primary" />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <div className="timeline-container">
                        <h4>TRACKING NUMBER CREATED</h4>
                        <h5>Driver Name</h5>
                        <p>Sep 03, 8:02 A.M</p>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot color="primary" />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <div className="timeline-container">
                        <h4>OUT FOR DELIVERY</h4>
                        <h5>Driver Name</h5>
                        <p>Sep 03, 8:02 A.M</p>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot />
                    </TimelineSeparator>
                    <TimelineContent>
                      <div className="timeline-container">
                        <h4 style={{ color: "black" }}>ARRIVING</h4>
                        <h5>Driver Name</h5>
                        <p>Sep 03, 8:02 A.M</p>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                </Timeline>
              </div>
            )}
            {activeTab === "driverInfo" && (
              <div>
                <p>Driver Info Content</p>
                {/* Add your driver info content here */}
              </div>
            )}
            {activeTab === "images" && (
              <div>
                <p>Images Content</p>
                {/* Add your images content here */}
              </div>
            )}
          </div>
        </div>
        <div className="pop-map">
          <button onClick={onClose}>Exit</button>
          <Gallery activeTab={activeTab} />
          <GoogleMapComponent activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
}

export default GridContent;
